import React from 'react';

interface SeparatorWithTextProps {
	text?: string;
	className?: string;
}

const SeparatorWithText: React.FC<SeparatorWithTextProps> = ({ text, className = '' }) => {
	return (
		<div className={`flex w-full items-center ${className}`}>
			<div className="h-px flex-grow bg-[#D9D9D9]" />
			{text ? <span className="px-3 text-sm font-medium text-gray-300">{text}</span> : null}
			<div className="h-px flex-grow bg-[#D9D9D9]" />
		</div>
	);
};

export default SeparatorWithText;
